/* Blowhammer home 2026, rooms and discards (B-HOME 12/10/2026). The tavole wait with an empty src and their
   srcset in data-na-srcset. A row gets its images when it comes within 600px of the screen. On the
   phone the row is a horizontal strip: the sheets on screen load then, even the one that only peeks at
   the edge (it invites the swipe), the others as soon as a finger touches or scrolls that strip.
   Measured on 12/10: the third sheet of each room waits, 6 of 18, about 1.9 MB on an iPhone. Without
   IntersectionObserver everything loads at once; without JavaScript the <noscript> copy is shown. */
(function () {
  if (window.__naTavole) return;
  window.__naTavole = true;
  function carica(img) {
    if (!img.dataset.naSrcset) return;
    img.setAttribute('srcset', img.dataset.naSrcset);
    img.setAttribute('src', img.dataset.naSrc);
    img.removeAttribute('data-na-srcset');
  }
  function caricaTutte(riga) {
    riga.querySelectorAll('img[data-na-srcset]').forEach(carica);
  }
  function apri(riga) {
    if (riga.scrollWidth <= riga.clientWidth + 10) return caricaTutte(riga);
    var bordo = riga.getBoundingClientRect().left + riga.clientWidth;
    riga.querySelectorAll('img[data-na-srcset]').forEach(function (img) {
      if (img.getBoundingClientRect().left < bordo) carica(img);
    });
    ['pointerdown', 'touchstart', 'scroll'].forEach(function (evento) {
      riga.addEventListener(evento, function () { caricaTutte(riga); }, { passive: true, once: true });
    });
  }
  // S1 17/10/2026. On the phone a room shows one tavola per screen: the thin marks under the strip say which one is on screen.
  document.querySelectorAll('[data-na-fila]').forEach(function (fila) {
    var segni = fila.parentNode.querySelectorAll('.na-sala__segni i');
    if (!segni.length) return;
    var attesa = 0;
    fila.addEventListener('scroll', function () {
      if (attesa) return;
      attesa = requestAnimationFrame(function () {
        attesa = 0;
        var n = Math.round(Math.abs(fila.scrollLeft) / Math.max(1, fila.clientWidth));
        segni.forEach(function (s, i) { s.classList.toggle('is-on', i === Math.min(n, segni.length - 1)); });
      });
    }, { passive: true });
  });
  var righe = document.querySelectorAll('[data-na-differite]');
  if (!('IntersectionObserver' in window)) {
    righe.forEach(caricaTutte);
    return;
  }
  // observe after the load event or the first scroll, whichever comes first: in one phone run of four
  // (12/10, 16:06) the first check came during loading and fetched rooms 01-02 without any scrolling
  var avviato = false;
  function osserva() {
    if (avviato) return;
    avviato = true;
    var osservatore = new IntersectionObserver(function (voci) {
      voci.forEach(function (voce) {
        if (!voce.isIntersecting) return;
        apri(voce.target);
        osservatore.unobserve(voce.target);
      });
    }, { rootMargin: '600px 0px' });
    righe.forEach(function (riga) { osservatore.observe(riga); });
  }
  if (document.readyState === 'complete') osserva();
  else {
    window.addEventListener('load', osserva, { once: true });
    window.addEventListener('scroll', osserva, { once: true, passive: true });
  }
})();
